@import '../../../../utils/global.module.less';
@import '../messages_shared.module.less';

.content {
    .message_text_style();
    max-width: 70%;
}

.approveButton {
    .baseYesButtonStyle();
    & > i {
        transform: scale(2);
    }
}

.denyButton {
    & > i {
        transform: scale(2);
    }
    .baseNoButton();
}

.l3Grid {
    width: 100%;
    border: 1px solid #fec84b;
    border-radius: 20px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3);
    gap: 8px; /* Adjust spacing as needed */
    align-items: center;
    margin-right: 20px;
}

.l3_header {
    border-radius: 20px 20px 0px 0px;
    padding: 15px;
    background-color: #fffaeb;
    color: #dc6803;
    font-family: LustTextMedium;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.2;
}

.l3_text {
    padding: 15px;
    color: #dc6803;
    font-family: Hanken Grotesk;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.2;
}

.cta_button {
    padding: 15px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
